export class EgHomeModel {
  Dashboard: string;
}
